import { gql } from '@apollo/client'

// Últimas aulas vistas da matrícula no produto principal, pelo mesmo critério
// do "Continue" da home (`updated_at` do progresso, mais recente primeiro).
export const GET_FEATURED_CONTINUE_LESSONS = gql`
  query getFeaturedContinueLessons($id: ID!, $courseId: ID!, $limit: Int!) {
    enrollment(id: $id) {
      id
      activatedAt
      status
      courseClassRelease(courseId: $courseId) {
        enabled
        startAt
        defaultOffset
      }
      schoolProduct {
        id
        title
        courses {
          id
          kind
        }
      }
      progressCard(courseId: $courseId) {
        id
        lessonsProgresses(
          ordenation: { by: "updatedAt", direction: "desc" }
          pagination: { offset: 0, limit: $limit }
        ) {
          id
          completed
          progress
          lesson {
            id
            courseContentId
            title
            releaseAt
            releaseAfter
            courseClassReleaseOffset
            lockAt
            lockAfter
            activity {
              id
              examQuestionsCount
            }
            coverImage {
              cdnFileUrl
            }
            media {
              id
              type
              originUrl
              providerKey
              fileExt
              hostKey
              host
              organizationUuid
              text
            }
          }
        }
      }
    }
  }
`
